import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { TP_COLORS } from '../../../../constants';
import { whiteButtonStyles } from '../../../../components/Button/styles';

export interface StudentsJumbotronProps {
  onBack?: () => void;
}

const StudentsJumbotron: React.FC<StudentsJumbotronProps> = ({ onBack }) => {
  return (
    <div
      style={{
        marginBottom: '30px',
        padding: '0 5%',
        background: 'linear-gradient(264deg, #4DE6B3, #65CFCD)',
      }}
    >
      {Boolean(onBack) && (
        <div
          style={{
            padding: '30px',
            marginBottom: '-100px',
            marginLeft: '-5%',
          }}
        >
          <IconButton onClick={onBack} sx={whiteButtonStyles}>
            <ArrowBackIcon />
          </IconButton>
        </div>
      )}
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        style={{
          background: `url('${process.env.PUBLIC_URL}/images/shapes/colored-3d-boxes.svg') bottom left/20% no-repeat, url('${process.env.PUBLIC_URL}/images/shapes/jigsaw-puzzle-items.svg') top right/30% no-repeat`,
          padding: '15px',
          minHeight: '180px',
        }}
      >
        <Typography
          component="h1"
          variant="h4"
          sx={{ color: TP_COLORS.white }}
          fontWeight={600}
        >
          Tutopiya Learning Platform
        </Typography>
        <Typography variant="h5" sx={{ color: TP_COLORS.white }}>
          Students
        </Typography>
      </Box>
    </div>
  );
};

export default StudentsJumbotron;
